import { Datagrid, List, TextField } from "react-admin";
import React from "react";

const ProjectList = (props) => (
	<List
		{...props}
		sort={{
			field: "creation_date",
			order: "DESC",
		}}
	>
		<Datagrid rowClick="show">
			<TextField label="Nom" source="project_name" />
			<TextField label="Établissement" source="establishment" />
			<TextField label="Identité" source="contact_identity" />
			<TextField label="Tél" source="contact_tel" />
			<TextField label="Mail" source="contact_email" />
			<TextField label="Montant" source="amount_project" />
			<TextField label="Description" source="description" />
			<TextField label="Création" source="creation_date" />
		</Datagrid>
	</List>
);

export default ProjectList;
